export { default as ReportTitle } from './primary';
